export enum EOrderDeliveryType {
  PICKUP = 'PICKUP',
  DELIVERY = 'DELIVERY',
}
